import { useEffect, useRef, useState } from "react";
import { Button } from "../../components/reusableComponents/Button";
import { Input } from "../../components/reusableComponents/Input";
import { Label } from "../../components/reusableComponents/Label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/reusableComponents/Select";
import { Textarea } from "../../components/reusableComponents/Textarea";
import qualifications from "../../utils/qualifications";
import axios from "../../axios/AxiosInstance";
import { DeleteIcon, Loader2, ShoppingBagIcon } from "lucide-react";
import MultiSelect from "../../components/reusableComponents/MultiSelect";
import { Checkbox } from "antd";
import { cacesList } from "../../utils/caces";
import { habilitationsList } from "../../utils/habilitation";
import LazyLoadingSelectQualification from "../../components/reusableComponents/LazyLoadingSelectQualification";

const CreateCommandeModal = ({
  close,
  orders,
  setOrders,
  setSelectedCommande,
}) => {
  const [clientSearch, setClientSearch] = useState("");
  const [client, setClient] = useState(null);
  const [isLoadingClient, setIsLoadingClient] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [timer, setTimer] = useState(null);
  const clientRef = useRef();
  const [clientAdressesArray, setClientAdressesArray] = useState([]);
  const [clientContactsArray, setClientContactsArray] = useState([]);
  const [usedMotif, setUsedMotif] = useState([]);
  const [prime, setPrime] = useState("");
  const [primeType, setPrimeType] = useState("");
  const [taux, setTaux] = useState("");
  const [diplomes, setDiplomes] = useState([]);
  const [habilitations, setHabilitations] = useState([]);
  const [caces, setCaces] = useState([]);
  const [permis, setPermis] = useState([]);
  const [missingFields, setMissingFields] = useState([]);

  const [formData, setFormData] = useState({
    client: null,
    startHour: null,
    endHour: null,
    contact: "",
    workedDays: [],
    nbHeureHebdo: "",
    justificatif: "",
    startDate: "",
    endDate: "",
    clientName: "",
    address: "",
    postCode: "",
    town: "",
    hourlyRate: "",
    typeContrat: "",
    motif: "",
    primes: [],
    consigne: "",
    isVehicule: false,
    diplomes: [],
    habilitations: [],
    caces: [],
    permis: [],
    epis: [],
    quantity: 1,
    qualification: "",
    task: "",
  });

  const setTask = (value) => {
    setFormData((prev) => ({ ...prev, task: value }));
  };

  const addWorkedDay = (day) => {
    setFormData((prev) => {
      const days = prev.workedDays.includes(day)
        ? prev.workedDays.filter((d) => d !== day)
        : [...prev.workedDays, day];
      return { ...prev, workedDays: days };
    });
  };

  const addPrime = () => {
    if (!prime || !primeType || !taux) return;
    const newPrime = { prime, primeType, taux };
    setFormData((prev) => ({
      ...prev,
      primes: [...prev.primes, newPrime],
    }));
    setPrime("");
    setPrimeType("");
    setTaux("");
  };

  const deletePrime = (index) => {
    setFormData((prev) => ({
      ...prev,
      primes: prev.primes.filter((_, i) => i !== index),
    }));
  };

  const selectNombreHeureHebdo = (value) => {
    setFormData((prev) => ({ ...prev, nbHeureHebdo: value }));
  };

  const loadRecours = () => {
    axios
      .get("pld-contract/recours")
      .then((res) => {
        console.log(res.data);
        setUsedMotif(
          res.data
            .map((moti) => moti.IdReferentiel + " : " + moti.Designation)
            .map((motif, idx) => {
              return { value: motif, label: motif, key: idx };
            }),
        );
      })
      .catch((e) => console.log(e));
  };

  const searchClient = (word) => {
    console.log(word);

    setClientSearch(word);
    if (word.length === 0) {
      setClients([]);
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer);
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer);

      const timer2 = setTimeout(() => {
        setIsLoadingClient(true);
        axios
          .post("client/freelance/find-by-text", { query: word })
          .then((res) => {
            setClients(res.data);
            setShowClientDropdown(true);
            console.log(res.data);
          })
          .catch((e) => console.log(e))
          .finally(() => setIsLoadingClient(false));
      }, 700);
      setTimer(timer2);
    }
  };

  useEffect(() => {
    loadRecours();

    const handleClickOutside = (event) => {
      if (clientRef.current && !clientRef.current.contains(event.target)) {
        setShowClientDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const selectConsigne = (value) => {
    setFormData((prev) => ({ ...prev, consigne: value }));
  };

  const selectQualification = (value) => {
    setFormData((prev) => ({ ...prev, qualification: value }));
  };

  const selectQuantity = (value) => {
    setFormData((prev) => ({ ...prev, quantity: value }));
  };

  const selectTypeContrat = (value) => {
    setFormData((prev) => ({ ...prev, typeContrat: value }));
  };

  const selectContact = (value) => {
    setFormData((prev) => ({ ...prev, contact: value }));
  };

  const selectMotif = (value) => {
    setFormData((prev) => ({ ...prev, motif: value }));
  };

  const licencesArray = [
    "AM",
    "A1",
    "A2",
    "A",
    "B1",
    "B",
    "C1",
    "C",
    "D1",
    "D",
    "BE",
    "C1E",
    "CE",
    "D1E",
    "DE",
  ];

  const diplomasArray = [
    "Aide soignant",
    "infirmier",
    "AES",
    "AMP",
    "BTS analyse biologique",
    "BP préparateur en pharmacie",
    "CAP - BEP",
    "Baccalauréat",
    "DEUG - BTS - DUT - DEUST",
    "Licence - BUT",
    "Maîtrise - Master",
    "Doctorat",
  ];

  const setAdressFromSiege = () => {
    if (!client) return;
    setFormData((prev) => ({
      ...prev,
      address: client.address || "",
      postCode: client.postCode || "",
      town: client.town || "",
    }));
  };

  const setAdressFromLivraison = () => {
    if (!client) return;
    setFormData((prev) => ({
      ...prev,
      address: client.addressLivraison || "",
      postCode: client.postCodeLivraison || "",
      town: client.townLivraison || "",
    }));
  };

  const setAdressFromFacturation = () => {
    if (!client) return;
    setFormData((prev) => ({
      ...prev,
      address: client.addressFacturation || "",
      postCode: client.postCodeFacturation || "",
      town: client.townFacturation || "",
    }));
  };

  const createCommande = (e) => {
    e.preventDefault();

    const requiredFields = [
      { key: "client", label: "Client" },
      { key: "address", label: "Adresse" },
      { key: "typeContrat", label: "typeContrat" },
      { key: "motif", label: "motif" },
      { key: "postCode", label: "Code postal" },
      { key: "town", label: "Ville" },
      { key: "clientName", label: "Nom du client final" },
      { key: "startHour", label: "Heure de début" },
      { key: "endHour", label: "Heure de fin" },
      { key: "workedDays", label: "Jours travaillés" },
      { key: "nbHeureHebdo", label: "Heures hebdomadaires" },
      { key: "hourlyRate", label: "Taux horaire" },
      { key: "justificatif", label: "Justificatif" },
      { key: "startDate", label: "Date de début" },
      { key: "endDate", label: "Date de fin" },
      { key: "consigne", label: "Consigne" },
      { key: "task", label: "Tâches/Missions" },
    ];

    const missing = requiredFields
      .filter(({ key }) => {
        const val = formData[key];
        if (Array.isArray(val)) return val.length === 0;
        if (typeof val === "object" && val !== null)
          return Object.keys(val).length === 0;
        return !val;
      })
      .map((f) => f.key);

    setMissingFields(missing);
    console.log(missing);

    if (missing.length > 0) return;

    // All good
    setIsLoading(true);
    axios
      .post("order/freelance", {
        ...formData,
        client: formData.client._id,
        companyName: formData.client.name,
      })
      .then((res) => {
        const newCommande = res.data.order;
        console.log(newCommande);
        newCommande.candidates = res.data.potentialCandidates;
        const contact = newCommande.contact.split(" ");
        const phone = contact.pop();
        const email = contact.pop();
        const name = contact.join(" ");
        const newOrders = [{ ...newCommande, loading: false }, ...orders];
        setOrders(newOrders);
        setFormData({});
        setSelectedCommande({
          ...newCommande,
          contactData: { email, phone, name },
        });
        close();
      })
      .catch((e) => console.log(e))
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="fixed inset-0  bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white h-5/6 scrollbar-none  p-6 rounded-md shadow-md  w-3/5 relative max-h-screen overflow-y-auto min-h-0">
        <button
          onClick={close}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 className="text-xl font-semibold mb-4 text-center">
          Créer une annonce
        </h2>

        <form onSubmit={createCommande}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-5">
            <div className="space-y-2">
              <Label htmlFor="client">Client</Label>
              <div className="relative">
                <Input
                  value={clientSearch}
                  onFocus={() => {
                    setShowClientDropdown(true);
                  }}
                  onChange={(e) => searchClient(e.target.value)}
                  placeholder="Rechercher le client"
                  className="w-full border border-gray-300 rounded-md pr-10 "
                />
                {isLoadingClient && (
                  <div className="absolute inset-y-0 right-3 flex items-center">
                    <svg
                      className="animate-spin h-4 w-4 text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  </div>
                )}
              </div>

              {showClientDropdown && clients.length > 0 && (
                <ul className="z-10 mt-1 w-11/12 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto">
                  {clients.map((client) => (
                    <li
                      key={client._id}
                      onClick={() => {
                        setFormData({
                          ...formData,
                          client: { _id: client._id, name: client.companyName },
                        });
                        setClient(client);
                        setShowClientDropdown(false);

                        // Génère les adresses
                        const clientAdresses = [
                          ` ${client.address} ${client.postCode} ${client.town} `.toUpperCase(),
                          `Adresse de livraison : ${client.addressLivraison} ${client.postCodeLivraison} ${client.townLivraison} `.toUpperCase(),
                          `Adresse de facturation : ${client.addressFacturation} ${client.postCodeFacturation} ${client.townFacturation} `.toUpperCase(),
                        ];

                        // Format adresses et contacts
                        setClientAdressesArray(
                          clientAdresses.map((address, idx) => ({
                            value: address,
                            label: address,
                            key: idx,
                          })),
                        );
                        setClientContactsArray(
                          client.contacts.map((contact, idx) => ({
                            value: `${contact.firstname} ${contact.lastname} ${contact.email} ${contact.mobile}`,
                            label: `${contact.firstname} ${contact.lastname} (${contact.email})`,
                            key: idx,
                          })),
                        );
                      }}
                      className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                        formData.client?._id === client._id
                          ? "bg-indigo-100 font-semibold"
                          : ""
                      }`}
                    >
                      {client.companyName}
                    </li>
                  ))}
                </ul>
              )}

              {formData.client && (
                <div className="flex flex-wrap gap-2 mt-2">
                  <span
                    key={formData.client._id}
                    className="flex items-center bg-indigo-100 text-indigo-800 text-sm font-medium px-3 py-1 rounded-full"
                  >
                    {formData.client.name}
                    <button
                      type="button"
                      onClick={() => {
                        setFormData({ ...formData, client: null });
                      }}
                      className="ml-2 text-indigo-500 hover:text-indigo-700 focus:outline-none"
                    >
                      &times;
                    </button>
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-2">
            {formData.client && (
              <>
                <div className="w-1/2 flex flex-col space-y-2">
                  <Label className="" htmlFor="contact">
                    Contact{" "}
                  </Label>
                  <Select onValueChange={selectContact} name="contact">
                    <SelectTrigger
                      className={`w-full ${missingFields.includes("contact") ? "border-red-500" : "border-gray-300"}`}
                      id="contact"
                    >
                      <SelectValue placeholder="Sélectionnez un contact" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      {clientContactsArray.map((contact) => (
                        <SelectItem key={contact.key} value={contact.value}>
                          {contact.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div className="w-1/2 flex flex-col space-y-2">
                  <Label htmlFor="adress">Adresse</Label>
                  <Select name="adress">
                    <SelectTrigger
                      className={`w-full ${missingFields.includes("adress") ? "border-red-500" : "border-gray-300"}`}
                      id="adress"
                    >
                      <SelectValue placeholder="Sélectionnez une adresse" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      {clientAdressesArray.map((address) => (
                        <SelectItem key={address.key} value={address.value}>
                          {address.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </>
            )}
          </div>

          <div className="space-y-2 mb-4">
            <Label htmlFor="typeContrat">Type de contrat</Label>
            <Select onValueChange={selectTypeContrat} name="typeContrat">
              <SelectTrigger
                className={`w-full ${missingFields.includes("typeContrat") ? "border-red-500" : "border-gray-300"}`}
                id="typeContrat"
              >
                <SelectValue placeholder="Sélectionnez un type de contrat" />
              </SelectTrigger>
              <SelectContent className="bg-white">
                <SelectItem value="Intérim">Intérim</SelectItem>
                <SelectItem value="Vacation">Vacation</SelectItem>
                <SelectItem value="CDD">CDD</SelectItem>
                <SelectItem value="CDI">CDI</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2 mb-4">
            <Label htmlFor="motif">Motif de recours</Label>
            <Select onValueChange={selectMotif} name="motif">
              <SelectTrigger
                className={`w-full ${missingFields.includes("motif") ? "border-red-500" : "border-gray-300"}`}
                id="motif"
              >
                <SelectValue placeholder="Sélectionnez un motif de recours" />
              </SelectTrigger>
              <SelectContent className="bg-white">
                {usedMotif.map((motif) => {
                  return (
                    <SelectItem key={motif.key} value={motif.value}>
                      {motif.value}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2 mb-4">
            <Label htmlFor="justificatif">Developper le motif</Label>
            <Input
              id="justificatif"
              type="text"
              placeholder="Justificatif"
              value={formData.justificatif}
              onChange={(e) =>
                setFormData({ ...formData, justificatif: e.target.value })
              }
              className={`w-full border  rounded-md pr-10 ${missingFields.includes("justificatif") ? "border-red-500" : "border-gray-300"}`}
            />
          </div>

          <div className="flex items-center space-x-2">
            <div className="flex flex-col space-y-2 mb-4 w-1/2">
              <Label htmlFor="justificatif">Date de debut</Label>
              <Input
                id="startDate"
                type="date"
                placeholder="Date de début"
                value={formData.startDate}
                onChange={(e) =>
                  setFormData({ ...formData, startDate: e.target.value })
                }
                className="w-full border border-gray-300 rounded-md"
              />
            </div>

            <div className="flex flex-col space-y-2 mb-4 w-1/2">
              <Label htmlFor="justificatif">Date de fin</Label>
              <Input
                id="endDate"
                type="date"
                placeholder="Date de fin"
                value={formData.endDate}
                onChange={(e) =>
                  setFormData({ ...formData, endDate: e.target.value })
                }
                className="border  border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div className="space-y-6 my-8">
            <Label>Horaire de la mission</Label>

            <div className="flex items-center space-x-4">
              <Input
                type="time"
                value={formData.startHour || ""}
                onChange={(e) =>
                  setFormData({ ...formData, startHour: e.target.value })
                }
                className="w-1/2 border border-gray-300 rounded-md"
                placeholder="Heure de début"
              />
              <Input
                type="time"
                value={formData.endHour || ""}
                onChange={(e) =>
                  setFormData({ ...formData, endHour: e.target.value })
                }
                className="w-1/2 border border-gray-300 rounded-md"
                placeholder="Heure de fin"
              />
            </div>

            <div>
              <Label htmlFor="workedDays">Jours travaillés</Label>

              <div className="flex flex-wrap justify-around gap-2 mt-4">
                {[
                  "Lundi",
                  "Mardi",
                  "Mercredi",
                  "Jeudi",
                  "Vendredi",
                  "Samedi",
                  "Dimanche",
                ].map((day) => (
                  <p
                    key={day}
                    onClick={() => addWorkedDay(day)}
                    className={`p-1 w-24 text-center cursor-pointer rounded-md ${
                      formData.workedDays.includes(day)
                        ? "bg-indigo-500 text-white"
                        : "border border-gray-200 text-gray-500"
                    }`}
                  >
                    {day}
                  </p>
                ))}
              </div>
            </div>

            <div>
              <Label htmlFor="nbHeureHebdo">Nombre heures hebdomadaire</Label>

              <Input
                type="number"
                placeholder="Nombre heures hebdomadaire"
                value={formData.nbHeureHebdo}
                onChange={(e) => selectNombreHeureHebdo(e.target.value)}
                className="border border-gray-300 rounded-md mt-4"
              />
            </div>
          </div>

          <div>
            <div className="mt-6">
              <Label>Lieu de la mission</Label>
              <div className="flex space-x-2 items-center justify-between mt-2 mb-4 text-sm">
                <p
                  onClick={() => setAdressFromSiege()}
                  className="text-blue-500 cursor-pointer hover:underline"
                >
                  Recopier l'adresse du siège
                </p>
                <p
                  onClick={() => setAdressFromLivraison()}
                  className="text-blue-500 cursor-pointer hover:underline"
                >
                  Recopier l'adresse de livraison
                </p>
                <p
                  onClick={() => setAdressFromFacturation()}
                  className="text-blue-500 cursor-pointer hover:underline"
                >
                  Recopier l'adresse de facturation
                </p>
              </div>
              <div className="flex flex-col items-center space-y-3">
                <Input
                  value={formData.clientName}
                  onChange={(e) =>
                    setFormData({ ...formData, clientName: e.target.value })
                  }
                  className="rounded-md border border-gray-300"
                  placeholder="Nom du client final"
                />
                <Input
                  value={formData.address}
                  onChange={(e) =>
                    setFormData({ ...formData, address: e.target.value })
                  }
                  className="rounded-md border border-gray-300"
                  placeholder="Adresse"
                />
                <Input
                  value={formData.postCode}
                  onChange={(e) =>
                    setFormData({ ...formData, postCode: e.target.value })
                  }
                  className="rounded-md border border-gray-300"
                  placeholder="Code postal"
                />
                <Input
                  value={formData.town}
                  onChange={(e) =>
                    setFormData({ ...formData, town: e.target.value })
                  }
                  className="rounded-md border border-gray-300"
                  placeholder="Ville"
                />
              </div>
            </div>
          </div>

          <div className="mt-6">
            <LazyLoadingSelectQualification
              qualifications={qualifications}
              formData={formData}
              setFormData={setFormData}
            />
            <Label>Quantité</Label>
            <div className="flex items-center space-x-4">
              <button
                type="button"
                onClick={() => selectQuantity(formData.quantity - 1)}
                className="text-xl"
              >
                -
              </button>
              <span className="text-xl">{formData.quantity}</span>
              <button
                type="button"
                onClick={() => selectQuantity(formData.quantity + 1)}
                className="text-xl"
              >
                +
              </button>
            </div>
          </div>

          <div className="mt-6">
            <div>
              <Label>Renseigner le taux horaire</Label>
              <div className="flex flex-col items-center space-y-3 mt-4">
                <Input
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      hourlyRate: e.target.value,
                    }))
                  }
                  value={formData.hourlyRate}
                  className="rounded-md border border-gray-300"
                  placeholder="Taux horaire"
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col mt-6  rounded-xl shadow-sm mb-6 bg-white">
            <Label className="mb-2">Renseigner primes/indemnités</Label>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="flex flex-col space-y-4">
                {/* Catégorie (Primes/Indemnités) */}
                <div>
                  <Label>Catégorie</Label>
                  <Select
                    onValueChange={(value) => setPrime(value)}
                    value={prime}
                  >
                    <SelectTrigger className="w-full" id="prime">
                      <SelectValue placeholder="Sélectionnez une catégorie" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      {[
                        { value: "Primes", label: "Primes", key: "Primes" },
                        {
                          value: "Indemnités",
                          label: "Indemnités",
                          key: "Indemnités",
                        },
                      ].map((item) => (
                        <SelectItem key={item.key} value={item.value}>
                          {item.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                {/* Type de prime */}
                <div>
                  <Label>Type de prime</Label>
                  <Input
                    onChange={(e) => setPrimeType(e.target.value)}
                    value={primeType}
                    className="rounded-md border border-gray-300"
                    placeholder="Type de prime"
                  />
                </div>

                {/* Taux ou montant */}
                <div>
                  <Label>Taux ou montant</Label>
                  <Input
                    onChange={(e) => setTaux(e.target.value)}
                    value={taux}
                    className="rounded-md border border-gray-300"
                    placeholder="Taux ou montant"
                  />
                </div>
              </div>

              {/* Bouton d'ajout */}
              <div className="flex items-end justify-start">
                <button
                  type="button"
                  onClick={addPrime}
                  className="rounded-lg bg-indigo-500 px-6 py-1 text-white hover:bg-mountain-600 transition flex items-center space-x-2"
                >
                  <ShoppingBagIcon className="w-5 h-5 " />
                  <span>Ajouter</span>
                </button>
              </div>
            </div>

            {formData.primes.length > 0 && (
              <div className="overflow-x-auto">
                <div className="grid grid-cols-4 gap-2 bg-gray-100 py-2 px-4 rounded-md text-sm font-semibold uppercase text-gray-600">
                  <p className="text-center">Prime</p>
                  <p className="text-center">Type de prime</p>
                  <p className="text-center">Taux / Montant</p>
                  <p className="text-center">Actions</p>
                </div>

                {formData.primes.map((prime, idx) => (
                  <div
                    key={idx}
                    className="grid grid-cols-4 gap-2 border-b py-2 px-4 text-sm items-center"
                  >
                    <p className="text-center">{prime.prime}</p>
                    <p className="text-center">{prime.primeType}</p>
                    <p className="text-center">{prime.taux}</p>
                    <p className="text-center">
                      <button
                        onClick={() => deletePrime(idx)}
                        className="text-red-500 hover:text-red-700 transition"
                      >
                        <DeleteIcon className="w-5 h-5 text-red" />
                      </button>
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="flex flex-col mt-6  rounded-xl shadow-sm mb-6 bg-white">
            <Label>Consignes particulières</Label>

            <div className="my-4">
              <Select value={formData.consigne} onValueChange={selectConsigne}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Sélectionnez une consigne" />
                </SelectTrigger>
                <SelectContent className="bg-white max-h-60 overflow-auto">
                  {[
                    { value: "0 : Aucune", key: "0" },
                    {
                      value:
                        "1 : Port des EPI obligatoire. Le respect des règles de sécurité et d'hygiène est obligatoire.",
                      key: "1",
                    },
                    {
                      value:
                        "2 : La formation sécurité est dispensée par le responsable en poste le jour de l'intégration.",
                      key: "2",
                    },
                    {
                      value:
                        "3 : Port des EPI obligatoire. Le respect des règles de sécurité et d'hygiène est obligatoire. La formation sécurité est dispensée par le responsable en poste le jour de l'intégration.",
                      key: "3",
                    },
                    {
                      value:
                        "4 : Port des EPI obligatoire. Le respect des règles de sécurité et d'hygiène est obligatoire. L'assurance du véhicule est à la charge de l'entreprise utilisatrice.",
                      key: "4",
                    },
                  ].map((option) => (
                    <SelectItem key={option.key} value={option.value}>
                      {option.value}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="flex flex-col mt-6 rounded-xl shadow-sm mb-6 bg-white">
            <Label className="mb-2">Être véhiculé(e) ?</Label>

            <div className="flex items-center space-x-10 mb-6">
              <label className="flex items-center space-x-2 cursor-pointer">
                <Checkbox
                  checked={formData.isVehicule}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      isVehicule: e.target.checked,
                    }))
                  }
                />
                <span>OUI</span>
              </label>
              <label className="flex items-center space-x-2 cursor-pointer">
                <Checkbox
                  checked={!formData.isVehicule}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      isVehicule: !e.target.checked,
                    }))
                  }
                />
                <span>NON</span>
              </label>
            </div>

            <Label className="text-lg mb-4">Prérequis</Label>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <MultiSelect
                options={diplomasArray.map((diploma) => ({
                  label: diploma,
                  value: diploma,
                }))}
                selected={diplomes}
                setSelected={setDiplomes}
                placeholder="Sélectionnez les diplômes"
              />

              <MultiSelect
                options={habilitationsList.map((habili) => ({
                  label: habili,
                  value: habili,
                }))}
                selected={habilitations}
                setSelected={setHabilitations}
                placeholder="Sélectionnez les habilitations"
              />

              <MultiSelect
                options={cacesList.map((caces) => ({
                  label: caces,
                  value: caces,
                }))}
                selected={caces}
                setSelected={setCaces}
                placeholder="Sélectionnez les CACES"
              />

              <MultiSelect
                options={licencesArray.map((licence) => ({
                  label: licence,
                  value: licence,
                }))}
                selected={permis}
                setSelected={setPermis}
                placeholder="Sélectionnez les permis"
              />
            </div>
          </div>

          <div className="flex flex-col mt-6  mb-20 bg-white">
            <div>
              <Label className="mb-2">Quelles sont les tâches/missions ?</Label>

              <div className="flex items-center my-6 justify-center">
                <Textarea
                  className="h-24 w-full"
                  onChange={(e) => setTask(e.target.value)}
                  value={formData.task}
                  placeholder="Précisez les missions à effectuer..."
                />
              </div>

              <p className="text-red-500 text-center font-semibold text-sm">
                ⚠️ Ne pas mentionner le nom du client
              </p>
            </div>
          </div>

          <div className="mt-6 flex justify-end">
            <Button
              type="submit"
              className="bg-blue-600 text-white flex-justify-center"
            >
              {!isLoading && <span>Créer l'annonce</span>}
              {isLoading && (
                <span>
                  <Loader2 className="w-5 h-5" />
                </span>
              )}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCommandeModal;
